module.exports = new __parcel__URL__("project-fields-benefits-modal.3200c78b.png").toString();